module.exports = {
  footerText: "Copyright JARS Services Pvt. Ltd. © 2022",
};
